
const CommonTypes = {
  WORD: 'word',
  PDF: 'pdf',
  SPREADSHEET: 'spreadsheet',
  CSV: 'csv',
  SLIDES: 'slides',
  IMAGE: 'image',
  ZIP: 'zip',
};

const makeTypeObj = ({label, extensions, mimeTypes}) => {
  const accepts = [...mimeTypes, ...extensions.map(ext => `.${ext}`)];
  return {label, extensions, mimeTypes, accepts};
};

const typeObjs = {
  [CommonTypes.WORD]: makeTypeObj({
    label: 'Word Doc',
    extensions: ['doc', 'docx'],
    mimeTypes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  }),
  [CommonTypes.PDF]: makeTypeObj({
    label: 'PDF',
    extensions: ['pdf'],
    mimeTypes: ['application/pdf'],
  }),
  [CommonTypes.SPREADSHEET]: makeTypeObj({
    label: 'Spreadsheet',
    extensions: ['xls', 'xlsx'],
    mimeTypes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  }),
  [CommonTypes.CSV]: makeTypeObj({
    label: 'CSV',
    extensions: ['csv'],
    mimeTypes: ['text/csv'],
  }),
  [CommonTypes.SLIDES]: makeTypeObj({
    label: 'Presentation',
    extensions: ['ppt', 'pptx'],
    mimeTypes: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  }),
  [CommonTypes.IMAGE]: makeTypeObj({
    label: 'Image',
    extensions: ['png', 'jpg', 'jpeg', 'gif'],
    mimeTypes: ['image/jpeg', 'image/png', 'image/gif'],
  }),
  [CommonTypes.ZIP]: makeTypeObj({
    label: 'ZIP',
    extensions: ['zip'],
    mimeTypes: ['application/zip', 'application/x-zip-compressed'],
  }),
};

const getNameAndExt = (pathName) => {
  if (pathName == null) return [null, null];
  const parts = pathName.split('.');
  const last = parts.pop();
  const ext = last ? `.${last}` : null;
  const name = parts.join('.');
  return [name, ext];
};

const getTypeFromExt = (dirtyExt, dirtyMimeType) => {
  const ext = (dirtyExt || '').toLowerCase();
  const mimeType = (dirtyMimeType || '').toLowerCase();
  if ((mimeType || '').startsWith('image/')) return typeObjs[CommonTypes.IMAGE];
  return Object.values(typeObjs).find((obj) => {
    if (obj.accepts.includes(mimeType)) return true;
    if (obj.extensions.includes(ext)) return true;
    return false;
  }) || null;
};

// for just the name without extension
const sanitizeFilename = (filename) => {
  return (filename || '').replace(/\s+/g, '_').replace(/[^0-9a-zA-Z-_]+/g, '-');
};

// for name+extension
const sanitizeFullFilename = (filename) => {
  const [dirtyName, dirtyExt] = getNameAndExt(filename);
  let name = sanitizeFilename(dirtyName);
  const ext = (dirtyExt || '').toLowerCase();
  if (ext) name += ext;
  return name;
};

export default {
  CommonTypes,
  typeObjs,
  getNameAndExt,
  getTypeFromExt,
  sanitizeFilename,
  sanitizeFullFilename,
};
